import {
  ArrowRightIcon,
  Calendar1Icon,
  Checkbox,
  FinanaceIcon,
  FormControlLabel,
  GKButton,
  Grid2,
  NotesIcon,
  Popover,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  TagBorderIcon,
  Typography,
} from "components";
import dayjs from "dayjs";
import { useState } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch } from "store/store";
import { paletteLightTheme } from "utils/ColorTheme";
import { getHexaColor } from "utils/constants";
import { matchDate } from "utils/helpers";

interface LeadObject {
  id: number;
  activityType: string;
  idOfTask: string;
  data: {
    data: {
      id: number;
      city: string;
      name: string;
      tags: number[];
      email: string;
      state: string;
      branch: number;
      address: string;
      country: string;
      pincode: string;
      position: string;
      hasNotes: boolean;
      tagsList: {
        id: number;
        tag: string;
        branch: number;
        createdAt: string;
        updatedAt: string;
      }[];
      createdAt: string;
      leadValue: number;
      panNumber: string;
      updatedAt: string;
      description: string;
      hasMeeting: boolean;
      leadStatus: number;
      notesCount: number;
      riskStatus: string;
      companyName: string;
      countryCode: string;
      phoneNumber: string;
      meetingCount: number;
      lastContacted: string;
      sourceOfLead: number;
      leadStatusStr: string;
      leadAssignedTo: number;
      conversionStatus: boolean;
      sourceOfLeadStr: string;
      leadAssignedToStr: string;
    };
    current: string;
    message: string;
    previous: string;
  };
  action: string;
  createdAt: string;
  updatedAt: string;
  lead: number;
}

enum ActivityType {
  MEETING = "Meeting",
  NOTES = "Notes",
  STATUS = "Status",
  CONVERSION = "Conversion",
}

const LeadLogs = ({ data }: any) => {
  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleReturnTitle = (item: any) => {
    if (item.activityType === ActivityType.STATUS) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography fontWeight={600}>
            {item.data.data.leadAssignedToStr || "-"}
          </Typography>
          <Typography color={"var(--neutral-500)"} fontWeight={14}>
            Changed status from
          </Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.MEETING) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography fontWeight={600}>
            {item.data.data.leadAssignedToStr || "-"}
          </Typography>
          <Typography color={"var(--neutral-500)"} fontWeight={14}>
            added{" "}
          </Typography>
          <Typography fontWeight={600}>Meeting</Typography>
          <Typography fontWeight={600}>{item.data.data.note}</Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.NOTES) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography fontWeight={600}>
            {item.data.data.leadAssignedToStr || "-"}
          </Typography>
          <Typography color={"var(--neutral-500)"} fontWeight={14}>
            added{" "}
          </Typography>
          <Typography fontWeight={600}>Notes</Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.CONVERSION) {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography fontWeight={600}>
            {item.data.data.leadAssignedToStr || "-"}
          </Typography>
          <Typography color={"var(--neutral-500)"} fontWeight={14}>
            Converted
          </Typography>
          <Typography fontWeight={600}>Lead to Client</Typography>
        </div>
      );
    }

    return "-";
  };

  const handleReturnSummary = (item: LeadObject) => {
    if (item.activityType === ActivityType.STATUS) {
      return (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Typography
              fontWeight={500}
              color={getHexaColor(`${item.data.previous}`)}
            >
              {item.data.previous || "-"}
            </Typography>
            <ArrowRightIcon color={"var(--neutral-500)"} />
            <Typography
              fontWeight={500}
              color={getHexaColor(`${item.data.current}`)}
            >
              {item.data.current || "-"}
            </Typography>
          </div>
          <Typography
            fontWeight={500}
            color={"var(--neutral-500)"}
            fontSize={10}
          >
            {matchDate(item?.updatedAt) || "-"} of{" "}
            {dayjs(item?.updatedAt).format(`h:mm A`)}
          </Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.MEETING) {
      return (
        <div
          style={{
            display: "flex",
            gap: 8,
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <GKButton
            variant="link"
            onClick={() => {
              dispatch(TAB({ tabKey: "leadDetailsTabs", tabValue: 1 }));
            }}
          >
            View Meeting
          </GKButton>
          <Typography
            fontWeight={500}
            color={"var(--neutral-500)"}
            fontSize={10}
          >
            {matchDate(item?.updatedAt) || "-"} of{" "}
            {dayjs(item?.updatedAt).format(`h:mm A`)}
          </Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.NOTES) {
      return (
        <div
          style={{
            display: "flex",
            gap: 8,
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <GKButton
            variant="link"
            onClick={() => {
              dispatch(TAB({ tabKey: "leadDetailsTabs", tabValue: 2 }));
            }}
          >
            View Notes
          </GKButton>
          <Typography
            fontWeight={500}
            color={"var(--neutral-500)"}
            fontSize={10}
          >
            {matchDate(item?.updatedAt) || "-"} of{" "}
            {dayjs(item?.updatedAt).format(`h:mm A`)}
          </Typography>
        </div>
      );
    }
    if (item.activityType === ActivityType.CONVERSION) {
      return (
        <div
          style={{
            display: "flex",
            gap: 8,
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            fontWeight={500}
            color={"var(--neutral-500)"}
            fontSize={10}
          >
            {matchDate(item?.updatedAt) || "-"} of{" "}
            {dayjs(item?.updatedAt).format(`h:mm A`)}
          </Typography>
        </div>
      );
    }

    return " ";
  };

  const handleReturnIcons = (item: any) => {
    if (item.activityType === ActivityType.STATUS) {
      return <TagBorderIcon color={"var(--neutral-500)"} />;
    }
    if (item.activityType === ActivityType.MEETING) {
      return <Calendar1Icon color={"var(--neutral-500)"} />;
    }
    if (item.activityType === ActivityType.NOTES) {
      return <NotesIcon color={"var(--neutral-500)"} />;
    }
    if (item.activityType === ActivityType.CONVERSION) {
      return <FinanaceIcon color={"var(--neutral-500)"} />;
    }
    return <TagBorderIcon color={"var(--neutral-500)"} />;
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={6} display={"flex"} alignItems={"center"}>
          <Typography fontWeight={600} fontSize={16}>
            Status Logs
          </Typography>
        </Grid2>
        {/* <Grid2 size={6} textAlign={"right"}>
          <GKButton
            style={{
              padding: "6px 10px",
              color: "var(--neutral-500)",
              border: "1px solid #E3E8EF",
            }}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            Filter
          </GKButton>
        </Grid2> */}
        <Grid2 size={12} maxHeight={`calc(100vh - 270px)`} overflow={"auto"}>
          <Stepper orientation="vertical">
            {data?.map((step: any) => (
              <Step key={step.activityType} active>
                <StepLabel
                  sx={{ padding: 0 }}
                  icon={
                    <div
                      style={{
                        padding: 6,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: `solid 1px ${paletteLightTheme.palette.border.main}`,
                        borderRadius: 100,
                      }}
                    >
                      {handleReturnIcons(step)}
                    </div>
                  }
                >
                  {handleReturnTitle(step)}
                </StepLabel>
                <StepContent>{handleReturnSummary(step)}</StepContent>
              </Step>
            ))}
          </Stepper>
        </Grid2>
      </Grid2>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        PaperProps={{
          style: {
            width: "12%",
            boxShadow: ` 4px 2px 8px 0px rgba(0, 0, 0, 0.13)`,
            borderRadius: 8,
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Grid2 container sx={{ py: "6px" }}>
          <Grid2
            size={12}
            borderBottom={`solid 1px ${paletteLightTheme.palette.border.main}`}
            py={1}
            px={2}
          >
            <Typography
              fontWeight={400}
              fontSize={12}
              color={"var(--neutral-500)"}
            >
              Filter By
            </Typography>
          </Grid2>
          <Grid2 size={12} display={"flex"} flexDirection={"column"}>
            <FormControlLabel control={<Checkbox />} label="All" />
            <FormControlLabel control={<Checkbox />} label="Status" />
            <FormControlLabel control={<Checkbox />} label="Notes" />
            <FormControlLabel control={<Checkbox />} label="Meetings" />
          </Grid2>
          <Grid2
            size={12}
            borderTop={`solid 1px ${paletteLightTheme.palette.border.main}`}
            py={1}
            px={2}
            display={"flex"}
            justifyContent={"space-between"}
            alignContent={"center"}
          >
            <GKButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() => {
                setAnchorEl(null);
              }}
            >
              Reset
            </GKButton>
            <GKButton
              variant="contained"
              size="small"
              onClick={() => {
                setAnchorEl(null);
              }}
            >
              Done
            </GKButton>
          </Grid2>
        </Grid2>
      </Popover>
    </>
  );
};

export default LeadLogs;
